import * as React from 'react';
import { List, ListItemText, makeStyles } from '@material-ui/core';
import { Icon } from '@mitie/material-ui-extensions';
import { faEdit, faMugHot, faUtensils } from '@fortawesome/pro-light-svg-icons';
import {
	faEdit as faEditSolid,
	faMugHot as faMugHotSolid,
	faUtensils as faUtensilsSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { stores } from '../../store';
import { IHeaderNavProps } from '../../types';
import { observer } from 'mobx-react-lite';
import sidebarUseStyles from '../../assets/css/SideBarCss';
import clsx from 'clsx';
const useStyles = makeStyles(theme => ({
	listChildItemSelected: {
		backgroundColor: '#CFDBE5 !important',
	},
	PermissionsView: {
		display: 'none',
	},
}));
const HeaderNav = observer((props: IHeaderNavProps) => {
	const routes = React.useContext(stores.context.routes);
	const classes = props.classNames;
	const [selectedItem, setSelectedItem] = React.useState('');
	const classesnew = useStyles();
	const classesSideBar = sidebarUseStyles();
	const { routeName } = routes;
	const appStores = React.useContext(stores.context.appStores);
	const [showRefuelList, setShowRefuelList] = React.useState(0);
	const [openCont, setOpenCont] = React.useState(false);
	const [contentClicked, setContentClicked] = React.useState(false);
	const user = React.useContext(stores.context.user);
	const contentManagementList: string[] = ['editMenus', 'refuelList', 'copyMenus', 'addMenus'];
	const contentManagementListSelected = !!routeName && !!contentManagementList.includes(routeName);
	const [open, setOpen] = React.useState(routeName === 'refuel' || contentManagementListSelected);
	const handleClick = () => {
		setOpen(true);
		setOpenCont(true);
	};
	React.useEffect(() => {
		if (user.permissions && user.permissions.Modules) {
			const refuelIndex = user.permissions.Modules.findIndex(
				(m: any) => m.ModuleId === '35FA69F9-7A9E-41FC-AFB3-A8BEFA4E4637',
			);

			if (user.permissions.Modules[refuelIndex] && user.permissions.Modules[refuelIndex].Read) {
				if (
					user.permissions.Modules[refuelIndex].Create &&
					user.permissions.Modules[refuelIndex].Update &&
					user.permissions.Modules[refuelIndex].Delete
				) {
					setShowRefuelList(1);
				}
			} else {
				setShowRefuelList(0);
			}
		} else {
			setShowRefuelList(0);
		}
	}, [user.permissions]);

	const navigateToPage = (route: string) => {
		routes.navigate(
			{ name: route },
			{
				clearParams: true,
			},
		);
	};
	const handleClickContn = () => {
		setOpenCont(!openCont);
		setOpen(true);
		setContentClicked(true);
	};
	React.useEffect(() => {
		if (contentClicked && !openCont) navigateToPage('refuel');
	});
	return (
		<>
			<List
				component={'ul'}
				disablePadding={true}
				className={
					user.modulePermissions && user.modulePermissions.REFUEL
						? props.drawerOpen
							? classes.sideBarList
							: classes.miniSideBarList
						: classesnew.PermissionsView
				}
			>
				<li
					title={!props.drawerOpen ? 'Refuel' : ''}
					onClick={() => {
						handleClick();
						navigateToPage('refuel');
						appStores.drawerOpen = false;
					}}
					aria-expanded={open}
					aria-controls="refuel-collapse"
				>
					<a
						aria-label={routeName === 'refuel' ? 'Refuel Current' : 'Refuel'}
						href="javascript:void(0)"
						className={clsx(
							'ancharTag',
							{
								subMenuMiniSideBar: !props.drawerOpen,
							},
							routeName === 'refuel' || contentManagementListSelected ? 'selected' : 'main-menu',
						)}
					>
						<span className={classes.listIcon}>
							<Icon icon={routeName === 'refuel' || contentManagementListSelected ? faMugHotSolid : faMugHot} />
						</span>
						{props.drawerOpen && <ListItemText primary="Refuel" />}
					</a>
				</li>
				<li>
					{open && showRefuelList === 1 ? (
						<>
							<List
								component={'ul'}
								id="refuel-collapse"
								aria-live="polite"
								disablePadding={true}
								className={props.drawerOpen ? classesSideBar.contentMenuFeed : classesSideBar.miniContentMenuFeed}
							>
								<li
									title={!props.drawerOpen ? 'Content Management' : ''}
									onClick={() => {
										handleClickContn();
										setSelectedItem('contentManagement');
										appStores.drawerOpen = false;
									}}
									aria-label={openCont ? 'Collapse content management' : 'Expand content management'}
									aria-expanded={openCont}
									aria-controls="content-management-collapse"
								>
									<button
										className={clsx(
											'ancharTag buttonFocus',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											contentManagementListSelected || openCont ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'refuelList' || openCont ? faEditSolid : faEdit} />
										</span>
										{props.drawerOpen && <ListItemText primary="Content Management" style={{ textAlign: 'left' }} />}
									</button>
								</li>

								<li>
									{openCont && (
										<List
											id="content-management-collapse"
											aria-live="polite"
											component="ul"
											disablePadding
											className={props.drawerOpen ? classesSideBar.contentMenuFeed : classesSideBar.miniContentMenuFeed}
										>
											<li
												title={!props.drawerOpen ? 'Edit Menus' : ''}
												onClick={() => {
													navigateToPage('refuelList');
													setSelectedItem('refuelList');
													if (contentManagementListSelected) setOpenCont(false);
													appStores.drawerOpen = false;
													if (routeName === selectedItem) navigateToPage('refuel');
													setTimeout(() => {
														document.getElementById('MenuList')?.focus();
													}, 50);
												}}
											>
												<a
													aria-label={routeName === 'refuelList' ? 'Edit Menus Current' : 'Edit Menus'}
													href="javascript:void(0)"
													className={clsx(
														'ancharTag',
														{
															subMenuMiniSideBar: !props.drawerOpen,
														},
														routeName === 'refuelList' || routeName === 'addMenus'
															? 'selected sub-menu-selected'
															: 'sub-menu',
													)}
												>
													<span className={classes.listIcon}>
														<Icon
															icon={
																routeName === 'refuelList' || routeName === 'addMenus' ? faUtensilsSolid : faUtensils
															}
														/>
													</span>
													{props.drawerOpen && <ListItemText primary="Edit Menus " style={{ paddingLeft: '0px' }} />}
												</a>
											</li>
										</List>
									)}
								</li>
							</List>
						</>
					) : (
						''
					)}
				</li>
			</List>
		</>
	);
});

export default HeaderNav;
